function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import featureEnabled from 'shared/helper/feature';
import { T, useTranslate } from 'shared/helper/translate';
import { price } from 'researcher/helpers/price';
import { getChinaLocalization } from 'shared/account/reducer';
import Link from 'shared/components/Link';
import { getApiBaseUrl } from 'shared/helper/request';
import { recordStart14DayTrialClick } from 'researcher/helpers/gtm';
import { getAvailablePlans, getChinaAvailableNewPlans } from '../reducer';
import { PADDLE_PLAN_TYPES } from '../constants';
import iThenticate from '../images/ithenticate.svg';
var PhasingOutAvailablePlans = function PhasingOutAvailablePlans(_ref) {
  var _ChinaAnnualPlanforEd, _ChinaAnnualPlanforEd2, _ChinaAnnualPlanforEd3, _ChinaAnnualPlanforEd4, _plans$plagiarism, _ChinaAnnualPlanforEd5, _ChinaAnnualPlanforEd6, _ChinaAnnualPlanforEd7, _ChinaAnnualPlanforEd8, _ChinaAnnualPlanforEd9, _ChinaAnnualPlanforEd10, _ChinaAnnualPlanforEd11, _ChinaAnnualPlanforEd12, _ChinaAnnualPlanforEd14, _annualPlan, _ChinaAnnualPlanforEd15, _monthlyPlan;
  var freeTrialExpiration = _ref.freeTrialExpiration,
    hasActivePlan = _ref.hasActivePlan;
  var user = useSelector(function (_ref2) {
    var user = _ref2.user;
    return user;
  });
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var isChinaUser = useSelector(getChinaLocalization);
  var annualPlan = null;
  var monthlyPlan = null;
  var _useSelector = useSelector(getChinaAvailableNewPlans),
    availablePlagiarismPlan = _useSelector.plagiarism;
  var ChinaAnnualPlanforEditAndTranslation = null;
  var ChinaAnnualPlanforEditOnly = null;
  var hasNotHadTrialAndNotOnActivePlan = !freeTrialExpiration && !hasActivePlan;
  var _ref3 = useSelector(getChinaAvailableNewPlans) || {},
    _ref3$premiumWithTran = _ref3.premiumWithTranslation,
    availableChinaPremiumPlans = _ref3$premiumWithTran === void 0 ? [] : _ref3$premiumWithTran;
  var _ref4 = useSelector(getChinaAvailableNewPlans) || {},
    _ref4$editingOnly = _ref4.editingOnly,
    availableChinaEditingPlans = _ref4$editingOnly === void 0 ? [] : _ref4$editingOnly;
  var _useSelector2 = useSelector(getAvailablePlans),
    availablePremiumPlans = _useSelector2.premium;
  availablePremiumPlans.forEach(function (plan) {
    if (plan.billingInterval === PADDLE_PLAN_TYPES.YEARLY) {
      annualPlan = plan;
    } else if (plan.billingInterval === PADDLE_PLAN_TYPES.MONTHLY) {
      monthlyPlan = plan;
    }
  });
  availableChinaPremiumPlans.forEach(function (plan) {
    if (plan.billingInterval === PADDLE_PLAN_TYPES.YEARLY) {
      ChinaAnnualPlanforEditAndTranslation = plan;
    }
  });
  availableChinaEditingPlans.forEach(function (plan) {
    if (plan.billingInterval === PADDLE_PLAN_TYPES.YEARLY) {
      ChinaAnnualPlanforEditOnly = plan;
    }
  });
  var plans = {
    plagiarism: {
      plagiarismOneTimePayment: availablePlagiarismPlan
    }
  };
  var isChinaCartNewPlansEnabled = featureEnabled('rubriq_china_cart_edit_only_plan');
  var deepSeekEnabled = featureEnabled('rubriq_china_deep_seek');
  var chinaIthenticateEnabled = featureEnabled('china_use_ithenticate_report');
  var discountForChina = featureEnabled('china_plans_discount_offers');
  var colClass = chinaIthenticateEnabled ? 'col-md-3' : 'col-md-4';
  var shouldShowFreeTrial = hasNotHadTrialAndNotOnActivePlan;

  // const PricingInfoForPlagiagrism = ({ amount }) => (
  //     <>
  //         <p className="pricing m-0 p-0 pb-1 fw-bold text-start">{price(user.currency, amount, true, true)} </p>
  //         <p className="pricing-extra align-items-center text-start col-8 mb-1">
  //             <T source="iThenticate_per_document" />
  //         </p>
  //     </>
  // );
  var navigate = useNavigate();
  var handleCardNavigation = function handleCardNavigation(path) {
    return function (e) {
      if (e.target.closest('a,button')) return;
      navigate(path);
    };
  };
  var handleCardKeyNavigation = function handleCardKeyNavigation(path) {
    return function (e) {
      if (e.target.closest('a,button')) return;
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        navigate(path);
      }
    };
  };
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    selectedPlan = _React$useState2[0],
    setSelectedPlan = _React$useState2[1];
  var isEditingCardClickable = isChinaUser && !!freeTrialExpiration;
  var shouldShowChinaFreeTrial = isChinaUser && !freeTrialExpiration && !hasActivePlan;
  var editingDiscountedPrice = ((_ChinaAnnualPlanforEd = ChinaAnnualPlanforEditOnly) === null || _ChinaAnnualPlanforEd === void 0 ? void 0 : _ChinaAnnualPlanforEd.price) * (1 - ((_ChinaAnnualPlanforEd2 = ChinaAnnualPlanforEditOnly) === null || _ChinaAnnualPlanforEd2 === void 0 ? void 0 : _ChinaAnnualPlanforEd2.discountPercent) / 100);
  var editingAndTranslationDiscountedPrice = ((_ChinaAnnualPlanforEd3 = ChinaAnnualPlanforEditAndTranslation) === null || _ChinaAnnualPlanforEd3 === void 0 ? void 0 : _ChinaAnnualPlanforEd3.price) * (1 - ((_ChinaAnnualPlanforEd4 = ChinaAnnualPlanforEditAndTranslation) === null || _ChinaAnnualPlanforEd4 === void 0 ? void 0 : _ChinaAnnualPlanforEd4.discountPercent) / 100);
  var plagiarismPlanCard = chinaIthenticateEnabled && /*#__PURE__*/React.createElement("div", {
    className: "".concat(colClass, " d-flex")
  }, /*#__PURE__*/React.createElement("div", {
    className: "card bg-white mt-4 mt-md-0 flex-grow-1 cursor-pointer \n".concat(selectedPlan === 'plagiarism' ? 'border-primary shadow' : ''),
    role: "link",
    style: {
      cursor: 'pointer'
    },
    tabIndex: 0,
    onClick: function onClick(e) {
      if (e.target.closest('a,button')) return;
      setSelectedPlan('plagiarism');
      navigate('/rubriq/plagiarism');
    },
    onKeyDown: function onKeyDown(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (e.target.closest('a,button')) return;
        setSelectedPlan('plagiarism');
        navigate('/rubriq/plagiarism');
      }
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-body d-flex flex-column"
  }, /*#__PURE__*/React.createElement("div", {
    className: "callout rubriq-plan-header mb-1 font-weight-bold"
  }, /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement(T, {
    source: "plagiarism_check"
  })), /*#__PURE__*/React.createElement("div", {
    className: "mb-2 justify-content-left"
  }, /*#__PURE__*/React.createElement(T, {
    source: "powered_by"
  }), " ", /*#__PURE__*/React.createElement("img", {
    src: iThenticate,
    alt: ""
  })), /*#__PURE__*/React.createElement("p", {
    className: "plan-text-description text-start text-muted"
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.plan-description"
  }))), /*#__PURE__*/React.createElement("p", {
    className: "pricing m-0 p-0 pb-1 fw-bold justify-content-left"
  }, price(user.currency, (_plans$plagiarism = plans.plagiarism) === null || _plans$plagiarism === void 0 ? void 0 : _plans$plagiarism.plagiarismOneTimePayment[0].price, true, true)), /*#__PURE__*/React.createElement("p", {
    className: "pricing-extra align-items-center text-start col-8 mb-1"
  }, /*#__PURE__*/React.createElement(T, {
    source: "iThenticate_per_document"
  })), /*#__PURE__*/React.createElement("div", {
    className: "p-0 m-0 mt-3 d-inline rubriq-plan-feature-list"
  }, /*#__PURE__*/React.createElement("p", {
    className: "fw-bold"
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.features"
  })), /*#__PURE__*/React.createElement(T.md, {
    source: "plagiarism-feature-list"
  })), /*#__PURE__*/React.createElement("div", {
    className: "text-center pt-1 mt-auto"
  }, /*#__PURE__*/React.createElement(Link, {
    className: "btn btn-outline-primary w-100",
    to: "/rubriq/plagiarism"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-truncate"
  }, /*#__PURE__*/React.createElement(T, {
    source: "get_your_report_now"
  })))))));
  return /*#__PURE__*/React.createElement("div", {
    className: "row pb-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(colClass, " d-flex")
  }, /*#__PURE__*/React.createElement("div", {
    className: "card bg-white mt-4 mt-md-0 flex-grow-1 ".concat(isEditingCardClickable ? 'cursor-pointer' : '', " ").concat(selectedPlan === 'editing' ? 'border-primary shadow' : ''),
    role: "link",
    style: {
      cursor: 'pointer'
    },
    tabIndex: 0,
    onClick: isEditingCardClickable ? function (e) {
      if (e.target.closest('a,button')) return;
      setSelectedPlan('editing');
      handleCardNavigation(isChinaUser ? '/rubriq/subscribe/cart/editing' : '/rubriq/plan/subscribe/premium')(e);
    } : undefined,
    onKeyDown: isEditingCardClickable ? handleCardKeyNavigation(isChinaUser ? '/rubriq/subscribe/cart/editing' : '/rubriq/plan/subscribe/premium') : undefined
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-body d-flex flex-column"
  }, /*#__PURE__*/React.createElement("div", {
    className: "callout rubriq-plan-header mb-1 font-weight-bold"
  }, /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement(T, {
    source: "curie.curie-premium"
  })), /*#__PURE__*/React.createElement("p", {
    className: "plan-text-description text-start text-muted"
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.plan-description"
  }))), !isChinaUser ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
    className: "pricing m-0 p-0 pb-1 fw-bold text-center"
  }, price(user.currency, ((_ChinaAnnualPlanforEd5 = ChinaAnnualPlanforEditOnly) === null || _ChinaAnnualPlanforEd5 === void 0 ? void 0 : _ChinaAnnualPlanforEd5.price) / 12, true, true), ' '), /*#__PURE__*/React.createElement("p", {
    className: "pricing-extra align-items-center text-center offset-2 col-8 mb-1"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.annual-per-month-billing",
    params: {
      price: price(user.currency, (_ChinaAnnualPlanforEd6 = ChinaAnnualPlanforEditOnly) === null || _ChinaAnnualPlanforEd6 === void 0 ? void 0 : _ChinaAnnualPlanforEd6.price, true, true)
    }
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null, discountForChina && ((_ChinaAnnualPlanforEd7 = ChinaAnnualPlanforEditOnly) === null || _ChinaAnnualPlanforEd7 === void 0 ? void 0 : _ChinaAnnualPlanforEd7.discountPercent) > 0 && ((_ChinaAnnualPlanforEd8 = ChinaAnnualPlanforEditOnly) === null || _ChinaAnnualPlanforEd8 === void 0 ? void 0 : _ChinaAnnualPlanforEd8.discountPercent) < 100 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-start"
  }, /*#__PURE__*/React.createElement("div", {
    className: "me-3 text-center d-flex flex-row"
  }, /*#__PURE__*/React.createElement("p", {
    className: "pricing m-0 p-0 pb-1 fw-bold text-start"
  }, price(user.currency, editingDiscountedPrice, true, true), ' '), /*#__PURE__*/React.createElement("div", {
    className: "text-uppercase ms-2 mt-1"
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'coral'
    }
  }, "(", (_ChinaAnnualPlanforEd9 = ChinaAnnualPlanforEditOnly) === null || _ChinaAnnualPlanforEd9 === void 0 ? void 0 : _ChinaAnnualPlanforEd9.discountPercent, "%", ' ', /*#__PURE__*/React.createElement(T, {
    source: "rubriq.off"
  }), ")"), /*#__PURE__*/React.createElement("div", {
    className: "text-line-through text-muted"
  }, price(user.currency, (_ChinaAnnualPlanforEd10 = ChinaAnnualPlanforEditOnly) === null || _ChinaAnnualPlanforEd10 === void 0 ? void 0 : _ChinaAnnualPlanforEd10.price, true, true), ' ')))), /*#__PURE__*/React.createElement("p", {
    className: "pricing-extra align-items-center text-start col-8 mb-1"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.yearly"
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
    className: "pricing m-0 p-0 pb-1 fw-bold text-start"
  }, price(user.currency, (_ChinaAnnualPlanforEd11 = ChinaAnnualPlanforEditOnly) === null || _ChinaAnnualPlanforEd11 === void 0 ? void 0 : _ChinaAnnualPlanforEd11.price, true, true), ' '), /*#__PURE__*/React.createElement("p", {
    className: "pricing-extra align-items-center text-start col-8 mb-1"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.yearly"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "p-0 m-0 mt-3 d-inline rubriq-plan-feature-list"
  }, /*#__PURE__*/React.createElement("p", {
    className: "fw-bold"
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.features"
  })), /*#__PURE__*/React.createElement(T.md, {
    source: "rubriq.premium-editing-feature-list"
  })), /*#__PURE__*/React.createElement("div", {
    className: "text-center pt-1 mt-auto"
  }, isChinaUser ? /*#__PURE__*/React.createElement("div", {
    className: "flex-column gap-2 d-flex align-items-center"
  }, /*#__PURE__*/React.createElement(Link, {
    type: "button",
    className: "btn btn-outline-primary w-100",
    to: "/rubriq/subscribe/cart/editing"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.buy-now"
  })), shouldShowChinaFreeTrial && /*#__PURE__*/React.createElement("button", {
    id: "start_14day_free_trial_btn_editing",
    "data-cn-trial-btn": "true",
    "data-cn-service-name": "Rubriq Premium",
    "data-price": (_ChinaAnnualPlanforEd12 = ChinaAnnualPlanforEditOnly) === null || _ChinaAnnualPlanforEd12 === void 0 ? void 0 : _ChinaAnnualPlanforEd12.price,
    type: "button",
    className: "btn btn-outline-primary w-100",
    onClick: function onClick() {
      var _ChinaAnnualPlanforEd13;
      recordStart14DayTrialClick({
        buttonId: 'start_14day_free_trial_btn_editing',
        productName: 'Rubriq Premium',
        displayedPrice: ((_ChinaAnnualPlanforEd13 = ChinaAnnualPlanforEditOnly) === null || _ChinaAnnualPlanforEd13 === void 0 || (_ChinaAnnualPlanforEd13 = _ChinaAnnualPlanforEd13.price) === null || _ChinaAnnualPlanforEd13 === void 0 ? void 0 : _ChinaAnnualPlanforEd13.toString()) || ''
      });
      setTimeout(function () {
        window.location.href = "".concat(getApiBaseUrl(), "/c/").concat(isChinaUser ? 'CurieFreeTrialChina' : 'CurieFreeTrial');
      }, 1000);
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-span"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.get-starter"
  })))) : /*#__PURE__*/React.createElement(Link, {
    className: "btn btn-primary",
    to: isChinaUser ? '/rubriq/subscribe' : '/rubriq/plan/subscribe/premium'
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.upgrade-to-premium-title"
  })))))), isChinaCartNewPlansEnabled && /*#__PURE__*/React.createElement("div", {
    className: "".concat(colClass, " d-flex")
  }, /*#__PURE__*/React.createElement("div", {
    className: "card bg-white mt-4 mt-md-0 flex-grow-1 cursor-pointer \n                        ".concat(selectedPlan === 'translation' ? 'border-primary shadow' : ''),
    role: "link",
    style: {
      cursor: 'pointer'
    },
    tabIndex: 0,
    onClick: function onClick(e) {
      if (e.target.closest('a,button')) return;
      setSelectedPlan('translation');
      handleCardNavigation(isChinaCartNewPlansEnabled ? '/rubriq/subscribe/cart/translation' : '/rubriq/plan/subscribe/premium')(e);
    },
    onKeyDown: function onKeyDown(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (e.target.closest('a,button')) return;
        setSelectedPlan('translation');
        handleCardKeyNavigation(isChinaCartNewPlansEnabled ? '/rubriq/subscribe/cart/translation' : '/rubriq/plan/subscribe/premium')(e);
      }
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-body d-flex flex-column"
  }, /*#__PURE__*/React.createElement("div", {
    className: "callout rubriq-plan-header mb-1 font-weight-bold"
  }, /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.rubriq-premium-with-translation"
  })), /*#__PURE__*/React.createElement("p", {
    className: "plan-text-description text-start text-muted"
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.plan-description"
  }))), !isChinaUser ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
    className: "pricing m-0 p-0 pb-1 fw-bold text-center"
  }, isChinaCartNewPlansEnabled ? price(user.currency, ((_ChinaAnnualPlanforEd14 = ChinaAnnualPlanforEditAndTranslation) === null || _ChinaAnnualPlanforEd14 === void 0 ? void 0 : _ChinaAnnualPlanforEd14.price) / 12, true, true) : price(user.currency, ((_annualPlan = annualPlan) === null || _annualPlan === void 0 ? void 0 : _annualPlan.price) / 12, true, true), ' '), /*#__PURE__*/React.createElement("p", {
    className: "pricing-extra align-items-center text-start col-8 mb-1"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.annual-per-month-billing",
    params: {
      price: isChinaCartNewPlansEnabled ? price(user.currency, (_ChinaAnnualPlanforEd15 = ChinaAnnualPlanforEditAndTranslation) === null || _ChinaAnnualPlanforEd15 === void 0 ? void 0 : _ChinaAnnualPlanforEd15.price, true, true) : price(user.currency, (_monthlyPlan = monthlyPlan) === null || _monthlyPlan === void 0 ? void 0 : _monthlyPlan.price, true, true)
    }
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, function (_annualPlan2) {
    if (isChinaCartNewPlansEnabled) {
      var _ChinaAnnualPlanforEd16, _ChinaAnnualPlanforEd17, _ChinaAnnualPlanforEd20;
      if (discountForChina && ((_ChinaAnnualPlanforEd16 = ChinaAnnualPlanforEditAndTranslation) === null || _ChinaAnnualPlanforEd16 === void 0 ? void 0 : _ChinaAnnualPlanforEd16.discountPercent) > 0 && ((_ChinaAnnualPlanforEd17 = ChinaAnnualPlanforEditAndTranslation) === null || _ChinaAnnualPlanforEd17 === void 0 ? void 0 : _ChinaAnnualPlanforEd17.discountPercent) < 100) {
        var _ChinaAnnualPlanforEd18, _ChinaAnnualPlanforEd19;
        return /*#__PURE__*/React.createElement("div", {
          className: "d-flex justify-content-start"
        }, /*#__PURE__*/React.createElement("div", {
          className: "me-3 text-center d-flex flex-row"
        }, /*#__PURE__*/React.createElement("p", {
          className: "pricing m-0 p-0 pb-1 fw-bold text-center"
        }, price(user.currency, editingAndTranslationDiscountedPrice, true, true), ' '), /*#__PURE__*/React.createElement("div", {
          className: "text-uppercase ms-2 mt-1"
        }, /*#__PURE__*/React.createElement("span", {
          style: {
            color: 'coral'
          }
        }, "(", (_ChinaAnnualPlanforEd18 = ChinaAnnualPlanforEditAndTranslation) === null || _ChinaAnnualPlanforEd18 === void 0 ? void 0 : _ChinaAnnualPlanforEd18.discountPercent, "% ", /*#__PURE__*/React.createElement(T, {
          source: "rubriq.off"
        }), ")"), /*#__PURE__*/React.createElement("div", {
          className: "text-line-through text-muted"
        }, price(user.currency, (_ChinaAnnualPlanforEd19 = ChinaAnnualPlanforEditAndTranslation) === null || _ChinaAnnualPlanforEd19 === void 0 ? void 0 : _ChinaAnnualPlanforEd19.price, true, true), ' '))));
      }
      return /*#__PURE__*/React.createElement("p", {
        className: "pricing m-0 p-0 pb-1 fw-bold text-start"
      }, price(user.currency, (_ChinaAnnualPlanforEd20 = ChinaAnnualPlanforEditAndTranslation) === null || _ChinaAnnualPlanforEd20 === void 0 ? void 0 : _ChinaAnnualPlanforEd20.price, true, true), ' ');
    }
    return /*#__PURE__*/React.createElement("p", {
      className: "pricing m-0 p-0 pb-1 fw-bold text-start"
    }, price(user.currency, (_annualPlan2 = annualPlan) === null || _annualPlan2 === void 0 ? void 0 : _annualPlan2.price, true, true));
  }()), /*#__PURE__*/React.createElement("p", {
    className: "pricing-extra align-items-center text-start col-8 mb-1"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.yearly"
  }))), deepSeekEnabled ? /*#__PURE__*/React.createElement("div", {
    className: "p-0 m-0 mt-3 d-inline rubriq-plan-feature-list"
  }, /*#__PURE__*/React.createElement("p", {
    className: "fw-bold"
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.features"
  })), /*#__PURE__*/React.createElement(T.md, {
    source: "rubriq.premium-with-translation-feature-list-deepseek"
  })) : /*#__PURE__*/React.createElement("div", {
    className: "p-0 m-0 mt-3 d-inline rubriq-plan-feature-list"
  }, /*#__PURE__*/React.createElement("p", {
    className: "fw-bold"
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.features"
  })), /*#__PURE__*/React.createElement(T.md, {
    source: "rubriq.premium-with-translation-feature-list"
  })), /*#__PURE__*/React.createElement("div", {
    className: "text-center pt-1 mt-auto"
  }, isChinaCartNewPlansEnabled ? /*#__PURE__*/React.createElement(Link, {
    type: "button",
    className: "btn btn-outline-primary w-100",
    to: "/rubriq/subscribe/cart/translation"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.buy-now"
  })) : /*#__PURE__*/React.createElement(Link, {
    className: "btn btn-primary",
    to: isChinaUser ? '/rubriq/subscribe' : '/rubriq/plan/subscribe/premium'
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.upgrade-to-premium-title"
  })))))), chinaIthenticateEnabled && plagiarismPlanCard, /*#__PURE__*/React.createElement("div", {
    className: "".concat(colClass, " d-flex")
  }, /*#__PURE__*/React.createElement("div", {
    className: "card bg-white mt-4 mt-md-0 flex-grow-1 cursor-pointer \n".concat(selectedPlan === 'group' ? 'border-primary shadow' : ''),
    role: "link",
    style: {
      cursor: 'pointer'
    },
    tabIndex: 0,
    onClick: function onClick(e) {
      if (e.target.closest('a,button')) return;
      setSelectedPlan('group');
      window.location.href = isChinaUser ? 'https://www.aje.cn/group-discounts' : 'https://www.aje.com/group-discounts';
    },
    onKeyDown: function onKeyDown(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (e.target.closest('a,button')) return;
        setSelectedPlan('group');
        window.location.href = isChinaUser ? 'https://www.aje.cn/group-discounts' : 'https://www.aje.com/group-discounts';
      }
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-body d-flex flex-column"
  }, /*#__PURE__*/React.createElement("div", {
    className: "callout rubriq-plan-header mb-1 font-weight-bold"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "justify-content-left"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.preferred-group"
  })), /*#__PURE__*/React.createElement("p", {
    className: "plan-text-description text-start text-muted"
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.group-plan-description"
  }))), /*#__PURE__*/React.createElement("p", {
    className: "pricing m-0 p-0 pb-1 fw-bold text-center rubriq-plan-price"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.custom"
  })), /*#__PURE__*/React.createElement("div", {
    className: "p-0 m-0 mt-3 d-inline rubriq-plan-feature-list"
  }, /*#__PURE__*/React.createElement("p", {
    className: "fw-bold"
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.features"
  })), /*#__PURE__*/React.createElement(T.md, {
    source: "curie.preferred-group-feature-list"
  })), /*#__PURE__*/React.createElement("div", {
    className: "text-center pt-1 mt-auto"
  }, /*#__PURE__*/React.createElement("a", {
    "aria-label": t('curie.contact-us'),
    className: "btn btn-outline-primary w-100",
    href: isChinaUser ? 'https://www.aje.cn/group-discounts' : 'https://www.aje.com/group-discounts'
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.contact-us"
  })))))));
};
export default PhasingOutAvailablePlans;